import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../api/axiosInstance";
import { IndicatorOrLaw, isIndicator, SearchInformation } from "../../../../interfaces/Indicator";
import { ErrorResponse } from "react-router-dom";
import { Pagination } from "../../../../interfaces/Pagination";
import { SEARCH_MODE_EXPANDED } from "../../../../utils/const";
const { REACT_APP_API_PATH } = process.env;

export interface GetIndicatorsQuery {
    rightsId?: string[];
    search?: string;
    indicatorIds?: string[];
    indicatorsType?: string[];
    dimension?: string[];
    subdimension?: string[];
    ods?: string[];
    priorityGroups?: string[];
    page: number
    limit: number;
    endPeriod?: number;
}

interface GetIndicatorResponse {
    indicator: IndicatorOrLaw[] | null;
    error?: boolean;
    pagination: Pagination;
    searchMeta?: SearchInformation
}

export const getIndicators = createAsyncThunk<
    GetIndicatorResponse,
    GetIndicatorsQuery,
    { rejectValue: ErrorResponse }
>(
    "display/indicators",
    async ({
        rightsId,
        search,
        indicatorIds,
        subdimension,
        page,
        limit,
        indicatorsType,
        dimension,
        ods,
        priorityGroups,
        endPeriod,
    }: GetIndicatorsQuery) => {
        try {
            const params = new URLSearchParams();

            if (rightsId?.length && !rightsId.includes('seleccionar')) {
                rightsId.forEach(id => params.append('rightsIds', id));
            }

            if (indicatorsType?.length) {
                indicatorsType.forEach(id => params.append('indicatorTypes', id));
            }

            if (search) {
                params.set('search', search);
                params.set('searchMode', SEARCH_MODE_EXPANDED);
            }

            if (indicatorIds?.length) {
                indicatorIds.forEach(id => params.append('indicatorIds', id));
            }

            if (dimension?.length) {
                dimension.forEach(d => params.append('dimensionIds', d));
            }

            if (subdimension?.length) {
                subdimension.forEach(s => params.append('subdimensionIds', s));
            }

            if (ods?.length) {
                ods.forEach(o => params.append('ods', o));
            }

            if (priorityGroups) {
                priorityGroups.forEach(gp => params.append('priorityGroupsIds', gp));
            }

            if (endPeriod) params.set('endPeriod', endPeriod.toString());
            if (page) params.set('page', String(page));
            if (limit) params.set('limit', String(limit));

            const url = `${REACT_APP_API_PATH}/indicadores?${params.toString()}`;
            const response = await axiosInstance.get(url);
            const data = response.data;

            return {
                indicator: data.data.data.map((item: any): IndicatorOrLaw =>
                    isIndicator(item)
                        ? { ...item, type: 'indicator' }
                        : { ...item, type: 'law' }
                ),
                pagination: {
                    currentPage: Number(data.data.page),
                    pageSize: Number(data.data.limit),
                    totalItems: Number(data.data.totalItems),
                    totalPages: Number(data.data.totalPages),
                },
                error: false,
                ...(data.data.searchMeta && {
                    searchMeta: data.data.searchMeta
                }),
            };
        } catch (error: any) {
            return {
                indicator: [],
                periodsToEvaluate: [],
                pagination: { totalItems: 0, currentPage: 0, totalPages: 0, pageSize: 0 },
                error: true,
            };
        }
    }
);